<template>
  <div
    v-if="totalItems > 0"
    class="pagination"
  >
    <md-button
      :disabled="blockButtons || currentPage === 1"
      @click="sendUpdate(-1)"
    >
      <md-icon>arrow_back</md-icon>
    </md-button>
    <div class="page-indicator">
      <template v-if="pageFormat === 'page'">
        Página {{ currentPage }} de {{ totalPages }}
      </template>
      <template v-else>
        {{ pageStart }} - {{ pageEnd }} de {{ totalItems }}
      </template>
    </div>
    <md-button
      :disabled="blockButtons || currentPage === totalPages"
      @click="sendUpdate(+1)"
    >
      <md-icon>arrow_forward</md-icon>
    </md-button>
  </div>
</template>

<script>
export default {
  name: "Pagination",
  props: {
    currentPage: {
      type: Number,
      default: 1,
    },
    totalItems: {
      type: Number,
      default: 0,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    pageFormat: {
      type: String,
      default: () => "page",
      validator: value => [ "page", "items" ].indexOf(value) !== -1,
    },
    updatePage: {
      type: Function,
      default: undefined,
    }
  },
  data: () => ({
    blockButtons: false,
  }),
  computed: {
    totalPages() {
      return Math.ceil(this.totalItems / this.pageSize);
    },
    pageStart() {
      return this.pageSize * (this.currentPage - 1) + 1;
    },
    pageEnd() {
      return Math.min(this.currentPage * this.pageSize, this.totalItems);
    },
  },
  methods: {
    async sendUpdate(delta) {
      this.blockButtons = true;
      
      if (this.updatePage) {
        await this.updatePage(
          this.currentPage + delta,
          this.pageSize,
        );
        this.blockButtons = false;
      } else {
        this.$emit("updatePage",
          this.currentPage + delta,
          this.pageSize,
          () => this.blockButtons = false
        );
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.pagination {
  display: flex;
  justify-content: flex-end;
  align-items: center;

  .page-indicator {
    padding: 0 10px;
  }
}
</style>
